import Input from '@/components/forms/Input'
import Button from '@/components/misc/Button'
import { SubmitHandler, useForm } from 'react-hook-form'
import TextArea from '@/components/forms/TextArea'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  createNewCategory,
  editNewCategory,
} from '@/api/containerCategoriesAPI'
import { GET_ALL_CATEGORIES_QUERY_KEY } from '../hooks/useServerLogisticCategory'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { Category } from '@/interfaces/containerCategory'

interface IProp {
  close: () => void
  categoryToEdit?: Category
}
export default function NewCategoryModal({ close, categoryToEdit }: IProp) {
  const { control, handleSubmit, setError } = useForm()
  const queryClient = useQueryClient()
  const [isSending, setIsSending] = useState(false)

  const createCategory = useMutation({
    mutationFn: createNewCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ALL_CATEGORIES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: ['container_categories'],
      })
      setIsSending(false)
      close()
      toast.success('La categoría ha sido creada con éxito.')
    },
  })

  const editCategory = useMutation({
    mutationFn: editNewCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ALL_CATEGORIES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: ['container_categories'],
      })
      setIsSending(false)
      close()
      toast.success('La categoría ha sido editada con éxito.')
    },
    onError: (response: Error) => {
      setIsSending(false)
      close()
      toast.error(
        JSON.stringify(
          (response as Error).message ||
            'Lo siento, ha ocurrido un error intentando editar'
        )
      )
    },
  })

  const onSubmit: SubmitHandler<
    Record<string, string | number | boolean | string[]>
  > = (data) => {
    if (!data.category_name) {
      setError(
        'category_name',
        {
          type: 'manual',
          message: '¡Este campo es requerido!',
        },
        { shouldFocus: true }
      )
      return
    }

    setIsSending(true)
    if (categoryToEdit) {
      editCategory.mutate({
        id: categoryToEdit.id,
        name: data.category_name as string,
        description: data.description as string,
      })
    } else {
      createCategory.mutate({
        name: data.category_name as string,
        description: data.description as string,
      })
    }
  }

  return (
    <div className={'flex h-full flex-col space-y-4'}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1 className={'mb-5 text-xl font-bold text-slate-700'}>
          {categoryToEdit ? 'Editar categoría' : 'Nueva categoría'}
        </h1>
        <div className="pb-6">
          <Input
            control={control}
            defaultValue={categoryToEdit?.name}
            label={'Nombre (*)'}
            name={'category_name'}
            placeholder={'Nombre...'}
          />
        </div>
        <div className="pb-2">
          <TextArea
            control={control}
            defaultValue={categoryToEdit?.description}
            label={'Descripción'}
            name={'description'}
            placeholder={'Descripción...'}
            textareaClassName={'h-24'}
          />
        </div>
        <div className={'mt-10 flex w-full justify-end'}>
          <Button
            disabled={isSending}
            loading={isSending}
            name={'Guardar'}
            type="submit"
          />
        </div>
      </form>
    </div>
  )
}
